<template lang="pug">
  v-dialog(
    :value="true"
    max-width="1000"
    @click:outside="$modals.close()"
  )
    v-card(
      min-height="500"
    ).pa-4
      v-card-title
        h4 Выбор изображения
        v-spacer
        v-btn(
          fab
          text
          @click="$modals.close()"
        )
          v-icon mdi-close

      v-card-text.mt-4
        v-tabs(
          v-model="tab"
          color="secondary"
        )
          v-tab Иконка
          v-tab Загрузка изображения
        v-tabs-items(
          v-model="tab"
        ).mt-5
          v-tab-item
            v-text-field(
              v-model="searchQ"
              placeholder="Название иконки"
              prepend-inner-icon="mdi-magnify"
              clearable
              outlined
              filled
              rounded
            )
            v-tabs(
              v-model="iconCategoryTab"
              color="secondary"
              vertical
            )
              v-tab.pick-icon-tab Направления
              v-tab.pick-icon-tab Статусы
              v-tab.pick-icon-tab Редактирование
              v-tab.pick-icon-tab Данные
              v-tab.pick-icon-tab Фигуры
              v-tab.pick-icon-tab Общее
              v-tab-item(
                v-for="(category, k) in iconDict"
                :key="k"
              )
                v-row.ml-2
                  v-col(cols=4 md=3 lg=2 xl=1)(
                    v-for="icon in category"
                    :key="icon"
                  )
                    v-card(
                      flat
                      color="grey lighten-5"
                      @click="pickIcon(icon)"
                    ).text-center.sdo-radius.pa-2
                      v-icon(
                        size=50
                      ) {{ icon }}
                      .caption {{ icon }}
          v-tab-item.d-flex.justify-center.align-center.fill-height
            v-sheet(width=600)
              image-cropper(
                ref="cropper"
                v-model="uploadedImg"
                :aspect-ratio="1"
                preview
                preview-rounded
                :preview-width="100"
                @update:url="pickImage"
              )
              v-card-actions
                v-spacer
                v-btn(color="success" @click="$refs.cropper.uploadCropped()") Применить

</template>

<script>
import Direction from '@/utils/icons-list/direction';
import Indications from '@/utils/icons-list/indication';
import Editing from '@/utils/icons-list/editing';
import Data from '@/utils/icons-list/data';
import Shape from '@/utils/icons-list/shape';
import Common from '@/utils/icons-list/common';
import ImageCropper from '@/components/InputFields/imageCropper.vue';

export default {
  components: {
    ImageCropper,
  },
  props: {
    successCallback: { type: Function, default: () => ({}) },
  },
  data: () => ({
    tab: null,
    iconCategoryTab: null,

    searchQ: null,
    uploadedImg: null,
  }),
  computed: {
    iconDict() {
      return {
        direction: Direction.map((i) => this.decodeIcon(i)),
        indication: Indications.map((i) => this.decodeIcon(i)),
        editing: Editing.map((i) => this.decodeIcon(i)),
        data: Data.map((i) => this.decodeIcon(i)),
        shape: Shape.map((i) => this.decodeIcon(i)),
        common: Common.map((i) => this.decodeIcon(i)),
      };
    },
    height() {
      return this.contentHeight || 300;
    },
  },
  methods: {
    /**
     * mdiHomeOutline -> mdi-home-outline
     */
    decodeIcon(icon) {
      const result = [];
      let lastIndex = 0;
      icon.split('').forEach((i, idx) => {
        if (i.match(/[A-Z]/g)) {
          result.push(icon.slice(lastIndex, idx));
          lastIndex = idx;
        }
      });
      result.push(icon.slice(lastIndex));
      return result.join('-').toLowerCase();
    },
    pickIcon(icon) {
      this.$emit('input', {
        value: icon,
        isIcon: true,
      });
      this.$modals.close();
    },
    pickImage(url) {
      this.$emit('input', {
        value: {
          filename: this.uploadedImg,
          url,
        },
        isIcon: false,
      });
      this.$modals.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.pick-icon-tab {
  justify-content: start;
  text-transform: none;
  font-weight: 600;
  border-radius: 8px;
}
</style>
